export const EXPIRED_TOKEN_MESSAGES = ['Expired JWT', 'expired_accessToken', 'Resources not found']

export const ERROR_CODE_MESSAGE = {
  SPACE_NOT_FOUND: 'SPACE_GATEWAY_002'
}
